import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

/**
 * Рендерит содержимое в слот действий верхней панели (#topbar-actions).
 * Нужно, чтобы страница могла положить свои кнопки в общий заголовок,
 * не держа их в разметке страницы.
 *
 * Пример:
 *   <TopbarAction>
 *     <button className="topbar-action">Добавить</button>
 *   </TopbarAction>
 */
export default function TopbarAction({ children }) {
  const [host, setHost] = useState(null);

  useEffect(() => {
    setHost(document.getElementById("topbar-actions"));
  }, []);

  if (!host || !children) return null;
  return createPortal(children, host);
}
